var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.sideMenuOpened,
          expression: "sideMenuOpened",
        },
      ],
      staticClass: "overlay-back",
    },
    [
      _c("div", { staticClass: "side-menu" }, [
        _c("div", {
          staticClass: "x-icon icon close",
          on: {
            click: function ($event) {
              return _vm.closeSideMenu()
            },
          },
        }),
        _c("div", { staticClass: "language-wrapper" }, [_c("Language")], 1),
        _c(
          "div",
          { staticClass: "menu-wrapper" },
          [
            _c("ul", [
              _c("li", { on: { click: _vm.openVerifyVignetteModal } }, [
                _vm._v(_vm._s(_vm.$t("check_vignette_valability"))),
              ]),
              _c(
                "li",
                {
                  staticClass: "resurse has-subpages",
                  on: {
                    click: function ($event) {
                      return _vm.displaySubpages()
                    },
                  },
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("resources")))]),
                  _vm.displayedSubPages
                    ? _c("ul", [
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: { name: "how-it-works" } },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.closeSideMenu()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("how_it_works")))]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: { name: "questions" } },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.closeSideMenu()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("faq_title")))]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: { name: "info" } },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.closeSideMenu()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("info")))]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: "about-us" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeSideMenu()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("about")) + " " + _vm._s(_vm.$t("us"))
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: "company-advanges" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeSideMenu()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("for_companies")))]
                  ),
                ],
                1
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: "distribution" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeSideMenu()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("distribution_untrr")))]
                  ),
                ],
                1
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: "contact" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeSideMenu()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("contact_title")))]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "router-link",
              {
                staticClass: "d-flex justify-content-end",
                attrs: { to: { name: "vignette" } },
                nativeOn: {
                  click: function ($event) {
                    return _vm.closeSideMenu()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-purple",
                    class: _vm.isMobile() ? "w-100" : "mr-2",
                    attrs: { type: "button" },
                  },
                  [_vm._v(_vm._s(_vm.$t("i_want_vignette")))]
                ),
              ]
            ),
            _c(
              "router-link",
              {
                staticClass: "d-flex justify-content-end",
                attrs: { to: { name: "toll" } },
                nativeOn: {
                  click: function ($event) {
                    return _vm.closeSideMenu()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-purple",
                    class: _vm.isMobile() ? "w-100" : "ml-2",
                    attrs: { type: "button" },
                  },
                  [_vm._v(_vm._s(_vm.$t("i_want_toll")))]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }